import React from "react";
import "./style.css";
import KeyboardArrowLeftIcon from "../../src/Assets/KeyboardArrowLeftIcon";
import KeyboardArrowRightIcon from "../../src/Assets/KeyboardArrowRightIcon";

export default function TablePagination({
  rowsPerPage,
  setRowsPerPage,
  currentPage,
  setCurrentPage,
  totalRows,
  bgColor,
}) {
  let totalPage = Math.ceil(totalRows / rowsPerPage) || 1;

  const prevPage = () => {
    if (currentPage == 1) return;
    setCurrentPage(currentPage - 1);
  };

  const nextPage = () => {
    if (currentPage == totalPage) return;
    setCurrentPage(currentPage + 1);
  };

  const setRows = (rows) => {
    setCurrentPage(1);
    setRowsPerPage(rows);
  };
  return (
    <>
      <div className="paginationContainer" style={{ backgroundColor: bgColor }}>
        <div className="flexDisplayRow">
          <div className="flexDisplayRow">
            <span>Items per page: </span>
            <select
              name="frequency"
              id="frequency"
              value={rowsPerPage}
              className="noOfRows"
              onChange={(e) => setRows(e.target.value)}
            >
              <option value="50">50</option>
              <option value="500">500</option>
              <option value="2500">2500</option>
              <option value="5000">5000</option>
            </select>
          </div>

          <button
            onClick={() => setCurrentPage(1)}
            style={{
              backgroundColor: "#808080",
              border: "none",
              borderRadius: "10px",
              width: "3.5rem",
              padding: "0.3rem",
              fontWeight: "bold",
              color: "#fff",
            }}
          >
            {"<<"}
          </button>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "5px",
            }}
          >
            <button
              onClick={prevPage}
              disabled={currentPage == 1}
              className={currentPage == 1 ? "pageButton1" : "pageButton"}
            >
              <KeyboardArrowLeftIcon color="#9FA2B4"/>
            </button>
            <span
              style={{
                width: "100px",
                textAlign: "center",
              }}
            >
              {Math.min(
                (currentPage - 1) * (rowsPerPage === "All" ? 0 : rowsPerPage) +
                  1,
                totalRows,
              )}{" "}
              -{" "}
              {rowsPerPage === "All"
                ? totalRows
                : Math.min(currentPage * rowsPerPage, totalRows)}{" "}
              of {totalRows}
            </span>
            <button
              onClick={nextPage}
              disabled={currentPage == totalPage}
              className={
                currentPage == totalPage ? "pageButton1" : "pageButton"
              }
            >
              <KeyboardArrowRightIcon color="#9FA2B4" />
            </button>
          </div>
          <button
            onClick={() => setCurrentPage(totalPage)}
            style={{
              backgroundColor: "#808080",
              border: "none",
              borderRadius: "10px",
              width: "3.5rem",
              padding: "0.3rem",
              fontWeight: "bold",
              color: "#fff",
            }}
          >
            {">>"}
          </button>
        </div>
      </div>
    </>
  );
}
